import React, { createContext, useContext, useState } from "react";

const BookingDetailContext = createContext();

export const BookingDetailProvider = ({ children }) => {
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [selectedJob, setSelectedJob] = useState(null);

  return (
    <BookingDetailContext.Provider
      value={{
        selectedBooking,
        setSelectedBooking,
        selectedJob,
        setSelectedJob,
      }}
    >
      {children}
    </BookingDetailContext.Provider>
  );
};

export const useBookingDetail = () => useContext(BookingDetailContext);